import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-frameworks',
	templateUrl:'./FrameworksPage.html',
	styles: [],
	styleUrls:['./FrameworksPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
		WaTagDirective,
		WaCardDirective,
		RouterModule,
		WaButtonDirective,
],
	standalone:true
})
export class FrameworksPage
{
	mdContent_43 = `JWebMP wraps complete UI frameworks as type-safe Java components with CRTP fluent APIs. Each framework's full component set is available — buttons, cards, modals, forms, navigation, and layout primitives — all configured in Java, rendered via Angular.`;
}
